import { $Q, $Qll } from '../utils/query-selector';
import { initializeCustomSelect } from './custom-select';

/**
 * It handles click in links
 * @param {HTMLElement} link : It is the element clicked
 * @param {HTMLCollection} menuLinks : It is the collection with menu links
 */
export const handleLinkClick = (link, menuLinks) => {
  if (link.classList.contains('active')) return;

  menuLinks.forEach((item) => {
    if (item.classList.contains('active')) {
      item.classList.remove('active');
    }
  });

  link.classList.add('active');
  link.parentNode.dataset.selected = link.dataset.id;
};

/**
 * It synchronizes mobile and desktop options
 * @param {HTMLElement} option : It is the option clicked
 * @param {String} query : It is the query for the option to synchronize
 */
export const syncOption = (option, query) => {
  const { id } = option.dataset;
  const dataSelected = option.parentNode.dataset.selected;
  if (!id || !dataSelected) return;

  const toSyncOption = $Q(`${query}[data-id='${id}']`);
  if (!toSyncOption) return;

  option.parentNode.dataset.selected = dataSelected;
  toSyncOption.click();
};

/**
 * Set storage when link is clicked from addresses
 * @param {HTMLElement} link : It is the list item which contains the link
 * @param {Number} index : It is index for link
 */
const setStorageClick = (link, index) => {
  const {
    dataset: { id },
  } = link;
  sessionStorage.setItem('sidebar-clicked', JSON.stringify({ id, index }));
};

/**
 * It checks if link has address href
 * @param {HTMLElement} link : It is the list item which contains the link
 * @param {Number} index : It is index for link
 * @returns {Boolean} boolean : It confirms if contains addresses as href
 */
export const checkAddress = (link, index) => {
  const anchor = link.firstElementChild;
  if (!anchor) return;

  const href = anchor.getAttribute('href');

  if (window.location.pathname.includes('account/addresses')) {
    setStorageClick(link, index);
    return true;
  }

  return href.includes('account/addresses');
};

/**
 * It adds events to menu links
 * @param {HTMLCollection} menuLinks : It is the collection with menu links
 */
const addLinksEvents = (menuLinks) => {
  menuLinks.forEach((link, index) => {
    link.addEventListener('click', (event) => {
      const isAddress = checkAddress(link, index);
      if (isAddress) return;

      event.preventDefault();
      handleLinkClick(link, menuLinks);
      syncOption(link, '.custom-select__items li');
      viewSection(index);
      window.scrollTo(0, 0);
    });
  });
};

/**
 * It shows the section clicked
 * @param {Number} index : It is the section index
 */
export const viewSection = (index) => {
  const customerSections = $Q('.customer__sections');
  if (!customerSections) return;

  const { children } = customerSections;

  Object.values(children).forEach((child, i) => {
    if (index === i) {
      child.classList.remove('hidden');
    } else {
      child.classList.add('hidden');
    }
  });
};

/* It gets the menu links */
const getMenuLinks = () => {
  const menuLinks = $Qll('.account-sidebar .account-sidebar__item');
  if (!menuLinks) return;

  addLinksEvents(menuLinks);
};

/**
 * Get storage click to view a determined section
 */
const getStorageClick = () => {
  const storageClick = JSON.parse(sessionStorage.getItem('sidebar-clicked'));

  if (window.location.pathname.includes('addresses')) return;

  if (storageClick) {
    $Q(`.account-sidebar__item.active`).classList.remove('active');
    const link = $Q(`li[data-id="${storageClick.id}"]`);
    link.classList.add('active');
    viewSection(storageClick.index);
  } else {
    viewSection(0);
  }
};

/* It initializes side menu for account */
export const initializeSideMenu = () => {
  getStorageClick();
  getMenuLinks();
  initializeCustomSelect();

  setTimeout(() => {
    $Q('.preload-window') && $Q('.preload-window').classList.add('preload-window--hidden');
    sessionStorage.removeItem('sidebar-clicked');
  }, 500);
};
